
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_39ths_8t5mi_17",
  "file-loading-overlay": "awsui_file-loading-overlay_39ths_8t5mi_49",
  "file-loading-overlay-single-row": "awsui_file-loading-overlay-single-row_39ths_8t5mi_54",
  "file-name-container": "awsui_file-name-container_39ths_8t5mi_58",
  "file-option-name": "awsui_file-option-name_39ths_8t5mi_88",
  "file-option-size": "awsui_file-option-size_39ths_8t5mi_89",
  "file-option-last-modified": "awsui_file-option-last-modified_39ths_8t5mi_90",
  "file-option": "awsui_file-option_39ths_8t5mi_88",
  "file-option-thumbnail": "awsui_file-option-thumbnail_39ths_8t5mi_103",
  "file-option-thumbnail-image": "awsui_file-option-thumbnail-image_39ths_8t5mi_107",
  "file-option-metadata": "awsui_file-option-metadata_39ths_8t5mi_120",
  "with-image": "awsui_with-image_39ths_8t5mi_123",
  "single-row-loading": "awsui_single-row-loading_39ths_8t5mi_126",
  "token": "awsui_token_39ths_8t5mi_130",
  "token-grid": "awsui_token-grid_39ths_8t5mi_137",
  "token-contains-image": "awsui_token-contains-image_39ths_8t5mi_146",
  "token-box": "awsui_token-box_39ths_8t5mi_150",
  "horizontal": "awsui_horizontal_39ths_8t5mi_169",
  "error": "awsui_error_39ths_8t5mi_177",
  "dismiss-button": "awsui_dismiss-button_39ths_8t5mi_181",
  "warning": "awsui_warning_39ths_8t5mi_187",
  "read-only": "awsui_read-only_39ths_8t5mi_197",
  "loading": "awsui_loading_39ths_8t5mi_210"
};
  